(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('slides-variant-changer', class extends baseComponent.default {
    elements = {
      slideShow: 'slide-show'
    }

    render() {
      if (!this.$slideShow) return;
      this.listenTo('variantChange', (e, data) => {

        console.log(e);        
          if (!data.variant.featured_media) return;

        const ParentSlideshowEl = document.querySelector('slides-variant-changer[section-id="'+ data.sectionId + '"]');
        if(ParentSlideshowEl) {
          const Main_variant_gallery_slideEl = ParentSlideshowEl.querySelector('.main_variant_gallery_slide');
          const Main_variant_thumb_slideEl = ParentSlideshowEl.querySelector('.main_variant_thumb_slide');

          const newVariantMediaSrc = data.variant.featured_media.preview_image.src;
          
          if(Main_variant_gallery_slideEl) {
           const Main_variant_gallery_slide_imageEl = Main_variant_gallery_slideEl.querySelector('img');
            if(Main_variant_gallery_slide_imageEl) {
              Main_variant_gallery_slide_imageEl.setAttribute('src',newVariantMediaSrc);
              Main_variant_gallery_slide_imageEl.removeAttribute('srcset');
            }
          }

           if(Main_variant_thumb_slideEl) {
           const Main_variant_thumb_slide_image_El = Main_variant_thumb_slideEl.querySelector('img');
            if(Main_variant_thumb_slide_image_El) {
              Main_variant_thumb_slide_image_El.setAttribute('src',newVariantMediaSrc);
              Main_variant_thumb_slide_image_El.removeAttribute('srcset');
            }
          }
          
          
        }
        
        
          // this.$slideShow.slideTo(data.variant.featured_media.position-1);
      })
    }

  });
})();